import { render, staticRenderFns } from "./taskToInquReply.vue?vue&type=template&id=13b581a6&scoped=true&"
import script from "./taskToInquReply.vue?vue&type=script&lang=js&"
export * from "./taskToInquReply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b581a6",
  null
  
)

export default component.exports